<template>
	<modal :modal-id="modalId" :title="modalTitle" :preloader="preloader" @submit="submit" @close-modal="closeModal"
		afterError :modal-scroll="false">
		<template slot="body">
			<app-overlay-loader v-if="preloader" />
			<form class="mb-0" :class="{ 'loading-opacity': preloader }" :method="selectedUrl ? 'post' : 'put'"
				ref="form" :data-url="selectedUrl
					? `${API_VOUCHER}/${inputs.id}`
					: `${API_VOUCHER}`
					">

				<!-- Specify Voucher to Student -->
				<div v-if="!setAsViewOnly" class="form-group row align-items-center">
					<label for="inputs_form_voucher_specify" class="col-sm-3 mb-0">
						{{ $t("form_voucher_specify") }}
					</label>
					<!-- <app-input id="inputs_form_voucher_specify" class="col-sm-9" type="switch"
						v-model="input_voucher_specify" @input="(data) => setVoucherSpecify(data)" /> -->
					<app-input id="inputs_form_voucher_specify" class="col-sm-9" type="radio" :list="voucherTypeList"
						v-model="input_voucher_specify" @input="(data) => setVoucherSpecify(data)" :required="true" />
				</div>
				<!-- Specify Voucher to Student -->

				<!-- Generated Voucher Code -->
				<div class="form-group row align-items-center">
					<label for="inputs_form_voucher_code" class="col-sm-3 mb-0">
						{{ $t("form_voucher_code") }}
					</label>
					<p class="col-sm-9 text-lg my-auto" v-html="input_voucher_code"></p>
				</div>
				<!-- Generated Voucher Code -->

				<!-- Voucher Category -->
				<div class="form-group row align-items-center">
					<label for="inputs_form_voucher_category" class="col-sm-3 mb-0">
						{{ $t("form_voucher_category") }}
					</label>
					<app-input id="inputs_form_voucher_category" class="col-sm-9" type="advance-search-select"
						:loaded-per-time="20" v-model="input_voucher_category"
						@input="(data) => setVoucherCategoryValue(data)" :fetch-url="`${API_VOUCHER_CATEGORY}`"
						:placeholder="$t('form_voucher_category')" list-value-field="description" :required="true"
						:read-only="setAsViewOnly" />
				</div>
				<!-- Voucher Category -->

				<!--To Student -->
				<div class="form-group row align-items-center" :class="{
					'd-none': !isNotVoucherGift,
				}">
					<label for="inputs_form_voucher_lead_to" class="col-sm-3 mb-0">
						{{ $t("form_voucher_lead_to") }}
					</label>
					<app-input id="inputs_form_voucher_lead_to" class="col-sm-9" type="advance-search-select"
						:loaded-per-time="20" v-model="input_voucher_lead_to" @input="(data) => setLeadToValue(data)"
						:fetch-url="`${API_LEAD}?sub_status_id_operator=!=&sub_status_id=13`"
						:placeholder="$t('form_voucher_lead_to')" list-value-field="full_name"
						:required="isNotVoucherGift" aria-autocomplete="none" :read-only="setAsViewOnly" />
				</div>
				<!-- To Student -->

				<!-- Valid From -->
				<div class="form-group row align-items-center">
					<!-- Academic Calendar -->
					<label for="inputs_form_voucher_academic_calendar" class="col-sm-3 mb-0">
						{{ $t("table_voucher_valid_from") }}
					</label>
					<app-input id="inputs_form_voucher_academic_calendar" class="col-sm-6" type="advance-search-select"
						:loaded-per-time="20" v-model="input_voucher_academic_calendar"
						@input="(data) => setAcademicCalendarValue(data)"
						:fetch-url="`${API_ACADEMIC_CALENDAR}?date_end=${new Date().toISOString().split('T')[0]}`"
						:placeholder="$t('form_voucher_academic_calendar')" list-value-field="academic_calendar_name"
						:required="true" aria-autocomplete="none" :read-only="setAsViewOnly" />
					<!-- Academic Calendar -->

					<!-- School Term -->
					<app-input id="inputs_form_voucher_school_term" class="col-sm-3" type="select"
						:list="schoolTermList" v-model="inputs.school_term"
						:placeholder="$t('form_voucher_school_term')" :required="true" aria-autocomplete="none"
						:read-only="setAsViewOnly" />
					<!-- School Term -->
				</div>
				<!-- Valid From -->

				<!-- Product -->
				<!-- <div class="form-group row align-items-center" :class="{
					'd-none': isNotVoucherGift,
				}">
					<label for="inputs_form_voucher_product" class="col-sm-3 mb-0">
						{{ $t("form_voucher_product") }}
					</label>
					<app-input id="inputs_form_voucher_product" class="col-sm-9" type="advance-search-select"
						:loaded-per-time="20" v-model="input_voucher_product" @input="setProductValue"
						:fetch-url="`${API_VOUCHER}/products?is_active=1`" :placeholder="$t('form_voucher_product')"
						list-value-field="name" :required="!isNotVoucherGift" :read-only="setAsViewOnly" />
				</div> -->
				<!-- Product -->

				<!-- Package -->
				<!-- <div class="form-group row align-items-center" :class="{
					'd-none': isNotVoucherGift,
				}">
					<label for="inputs_form_voucher_package" class="col-sm-3 mb-0">
						{{ $t("form_voucher_package") }}
					</label>
					<app-input id="inputs_form_voucher_package" class="col-sm-9" type="advance-search-select"
						:loaded-per-time="20" v-model="input_voucher_package" @input="setPackageValue"
						:fetch-url="`${API_VOUCHER}/packages?is_active=1&product_id=${inputs.product_id}`"
						:placeholder="$t('form_voucher_package')" list-value-field="package_name"
						:required="!isNotVoucherGift" :read-only="setAsViewOnly" />
				</div> -->
				<!-- Package -->

				<!-- Usage Limit -->
				<div class="form-group row align-items-center" :class="{
					'd-none': isNotVoucherGift,
				}">
					<label for="inputs_form_voucher_limit" class="col-sm-3 mb-0">
						{{ $t("form_voucher_limit") }}
					</label>
					<app-input id="inputs_form_voucher_limit" class="col-sm-9" type="number"
						v-model="inputs.usage_limit" :placeholder="$t('form_voucher_limit')"
						@input="() => generatedVoucherCode(false)" :read-only="setAsViewOnly" :min-number="1" />
				</div>
				<!-- Usage Limit -->

				<!-- Due Date -->
				<div class="form-group row align-items-center">
					<label for="inputs_form_voucher_due_date" class="col-sm-3 mb-0">
						{{ $t("form_voucher_due_date") }}
					</label>
					<app-input id="inputs_form_voucher_due_date" class="col-sm-9" type="date"
						:props="{ minDate: new Date() }" v-model="inputs.due_date" :placeholder="'Due Date'"
						:required="true" :read-only="setAsViewOnly" />
				</div>
				<!-- Due Date -->

				<!-- Reason -->
				<div class="form-group row align-items-center">
					<label for="inputs_form_voucher_reason" class="col-sm-3 mb-0">
						{{ $t("form_voucher_reason") }}
					</label>
					<app-input id="inputs_form_voucher_reason" class="col-sm-9" type="text" v-model="inputs.reason"
						:placeholder="$t('form_voucher_reason')" :read-only="setAsViewOnly" />
				</div>
				<!-- Reason -->

				<!-- Toggle Reward -->
				<!-- <div v-if="!isNotVoucherGift" class="form-group row align-items-center">
					<label for="inputs_form_voucher_apply_reward" class="col-sm-3 mb-0">
						{{ $t("form_voucher_apply_reward") }}
					</label>
					<app-input id="inputs_form_voucher_apply_reward" class="col-sm-9" type="switch"
						v-model="reward.input_voucher_apply" @input="setVoucherApplyReward" />
				</div> -->
				<!-- Toggle Reward -->

				<!-- Voucher Reward -->
				<div v-if="applyVoucherReward" class="ml-4 mt-4">
					<h5 class="mt-2 mb-4 text-sm">{{ $t("title_voucher_reward") }}</h5>

					<!-- Generated Voucher Code -->
					<div class="form-group row align-items-center">
						<label for="reward_inputs_form_voucher_code" class="col-sm-4 mb-0">
							{{ $t("form_voucher_code") }}
						</label>
						<p class="col-sm-8 text-lg my-auto" v-html="reward.input_voucher_code"></p>
					</div>
					<!-- Generated Voucher Code -->

					<!-- Voucher Category -->
					<div class="form-group row align-items-center">
						<label for="reward_inputs_form_voucher_category" class="col-sm-4 mb-0">
							{{ $t("form_voucher_category") }}
						</label>
						<app-input id="reward_inputs_form_voucher_category" class="col-sm-8"
							type="advance-search-select" :loaded-per-time="20" v-model="reward.input_voucher_category"
							@input="(data) => setVoucherCategoryValue(data, true)"
							:fetch-url="`${API_VOUCHER_CATEGORY}`" :placeholder="$t('form_voucher_category')"
							list-value-field="description" :required="applyVoucherReward" />
					</div>
					<!-- Voucher Category -->

					<!--To Student -->
					<div class="form-group row align-items-center">
						<label for="reward_inputs_form_voucher_lead_to" class="col-sm-4 mb-0">
							{{ $t("form_voucher_lead_to") }}
						</label>
						<app-input id="reward_inputs_form_voucher_lead_to" class="col-sm-8" type="advance-search-select"
							:loaded-per-time="20" v-model="reward.input_voucher_lead_to"
							@input="(data) => setLeadToValue(data, true)" :fetch-url="`${API_LEAD}`"
							:placeholder="$t('form_voucher_lead_to')" list-value-field="full_name"
							aria-autocomplete="none" :required="applyVoucherReward" />
					</div>
					<!-- To Student -->

					<!-- Valid From -->
					<div class="form-group row align-items-center">
						<!-- Academic Calendar -->
						<label for="reward_inputs_form_voucher_academic_calendar" class="col-sm-4 mb-0">
							{{ $t("table_voucher_valid_from") }}
						</label>
						<app-input id="reward_inputs_form_voucher_academic_calendar" class="col-sm-6"
							type="advance-search-select" :loaded-per-time="20"
							v-model="reward.input_voucher_academic_calendar"
							@input="(data) => setAcademicCalendarValue(data, true)"
							:fetch-url="`${API_ACADEMIC_CALENDAR}?date_end=${new Date().toISOString().split('T')[0]}`"
							:placeholder="$t('form_voucher_academic_calendar')"
							list-value-field="academic_calendar_name" :required="applyVoucherReward"
							aria-autocomplete="none" />
						<!-- Academic Calendar -->

						<!-- School Term -->
						<app-input id="reward_inputs_form_voucher_school_term" class="col-sm-2" type="select"
							:list="schoolTermList" v-model="inputs.reward.school_term"
							:placeholder="$t('form_voucher_school_term')" :required="applyVoucherReward"
							aria-autocomplete="none" />
						<!-- School Term -->
					</div>
					<!-- Valid From -->

					<!-- Due Date -->
					<div class="form-group row align-items-center">
						<label for="reward_inputs_form_voucher_due_date" class="col-sm-4 mb-0">
							{{ $t("form_voucher_due_date") }}
						</label>
						<app-input id="reward_inputs_form_voucher_due_date" class="col-sm-8" type="date"
							:props="{ minDate: new Date() }" v-model="inputs.reward.due_date" :placeholder="'Due Date'"
							:required="applyVoucherReward" />
					</div>
					<!-- Due Date -->

				</div>
				<!-- Voucher Reward -->
			</form>
		</template>
	</modal>
</template>

<script>
import { FormMixin } from "../../../../../core/mixins/form/FormMixin.js";
import { ModalMixin } from "../../../../Mixins/ModalMixin";
import { API_ACADEMIC_CALENDAR, API_STUDENT, API_LEAD, API_VOUCHER, API_VOUCHER_CATEGORY } from "../../../../Config/ApiUrl";

export default {
	name: "ModalForm",
	mixins: [FormMixin, ModalMixin],
	props: {
		tableId: String,
		formId: String,
		setAsViewOnly: {
			type: Boolean,
			default: false,
		},
		value: {
			type: Object,
			default: () => {
				return {
					// package: {
					// 	id: undefined,
					// 	package_name: '',
					// },
					// product: {
					// 	id: undefined,
					// 	name: '',
					// },
					lead_to: {
						id: undefined,
						name: '',
					},
					voucher_category: {
						id: undefined,
						code: '',
					},
					academic_calendar: {
						id: undefined,
						academic_calender_name: '',
						date_start: '',
						date_end: '',
					},
					school_term: 1,
					due_date: '',
					reason: '',
					reason_rejection: '',
					reward: {
						lead_to: {
							id: undefined,
							name: '',
						},
						voucher_category: {
							id: undefined,
							code: '',
						},
						academic_calendar: {
							id: undefined,
							academic_calender_name: '',
							date_start: '',
							date_end: '',
						},
						school_term: 1,
						due_date: '',
					},
				};
			},
		},
	},
	data() {
		return {
			preloader: false,
			API_VOUCHER: API_VOUCHER,
			API_VOUCHER_CATEGORY: API_VOUCHER_CATEGORY,
			API_ACADEMIC_CALENDAR: API_ACADEMIC_CALENDAR,
			API_STUDENT: API_STUDENT,
			API_LEAD: API_LEAD,
			input_voucher_specify: 'STUDENT',
			voucherTypeList: [
				{
					id: 'STUDENT',
					value: 'Student'
				},
				{
					id: 'GIFT',
					value: 'Gift'
				},
			],
			// input_voucher_suffix: 0,
			// input_voucher_package: {
			// 	id: this.value?.package?.id ?? 0,
			// 	package_name: this.value?.package?.package_name ?? "",
			// },
			// input_voucher_product: {
			// 	id: this.value?.product?.id ?? 0,
			// 	name: this.value?.product?.name ?? "",
			// },
			input_voucher_code: '',
			input_voucher_academic_calendar: {
				id: this.value?.academic_calendar?.id ?? 0,
				academic_calendar_name: this.value?.academic_calendar?.academic_calendar_name ?? "",
				date_start: this.value?.academic_calendar?.date_start ?? "",
				date_end: this.value?.academic_calendar?.date_end ?? "",
			},
			input_voucher_lead_to: {
				id: this.value?.lead_to?.id ?? 0,
				name: this.value?.lead_to?.name ?? "",
			},
			input_voucher_category: {
				id: this.value?.voucher_category?.id ?? 0,
				code: this.value?.voucher_category?.code ?? "",
			},
			reward: {
				input_voucher_apply: false,
				input_voucher_code: '',
				input_voucher_academic_calendar: {
					id: this.value?.reward?.academic_calendar?.id ?? 0,
					academic_calendar_name: this.value?.reward?.academic_calendar?.academic_calendar_name ?? "",
					date_start: this.value?.reward?.academic_calendar?.date_start ?? "",
					date_end: this.value?.reward?.academic_calendar?.date_end ?? "",
				},
				input_voucher_lead_to: {
					id: this.value?.reward?.lead_to?.id ?? 0,
					name: this.value?.reward?.lead_to?.name ?? "",
				},
				input_voucher_category: {
					id: this.value?.reward?.voucher_category?.id ?? 0,
					code: this.value?.reward?.voucher_category?.code ?? "",
				},
			},
			inputs: {
				name: "",
				is_gift: false,
				voucher_code: [],
				voucher_category_id: 0,
				academic_calendar_id: 0,
				school_term: 1,
				lead_to_id: null,
				due_date: new Date().toISOString().split('T')[0],
				reward: {
					voucher_code: '',
					voucher_category_id: 0,
					academic_calendar_id: 0,
					school_term: 1,
					lead_to_id: 0,
					due_date: new Date().toISOString().split('T')[0],
				},
			},
			schoolTermList: [
				{ id: 1, value: 'Term 1' },
				{ id: 2, value: 'Term 2' },
				{ id: 3, value: 'Term 3' },
				{ id: 4, value: 'Term 4' },
			],
			modalId: this.formId,
			modalTitle: this.$t("form_voucher_title_create"),
		};
	},
	created() {
		if (this.selectedUrl) {
			this.modalTitle = this.$t("form_voucher_title_edit");
			this.preloader = true;
		}
	},
	computed: {
		applyVoucherReward() {
			return this.reward.input_voucher_apply && !this.isNotVoucherGift;
		},
		isNotVoucherGift() {
			return this.input_voucher_specify != 'GIFT';
		},
	},
	methods: {
		submit() {
			if (!this.applyVoucherReward) {
				this.inputs.reward = null;
				this.reward.input_voucher_apply = false;
			}
			this.inputs.is_gift = !this.isNotVoucherGift;
			// console.log('submit.form:', this.inputs);
			// console.log('reward.input_voucher_apply:', this.reward.input_voucher_apply);
			this.save(this.inputs);
		},
		afterSuccess(response) {
			this.$toastr.s(response.data.message);
			this.$hub.$emit("reload-" + this.tableId);
		},
		afterError(response) {
			this.$toastr.e(response.data.message);
			this.$hub.$emit("reload-" + this.tableId);
		},
		afterJsValidationFail() {
			console.log("JS Validation Failed", this.fieldStatus);
		},
		afterSuccessFromGetEditData(response) {
			this.inputs = response.data;
			this.preloader = false;
		},
		generatedVoucherCode(isReward = false) {
			let voucherCategory = 'XXX';
			let usageLimit = 1;
			if (isReward) {
				voucherCategory = this.reward.input_voucher_category?.code ?? voucherCategory;
				usageLimit = this.inputs.reward.usage_limit ?? usageLimit;
			} else {
				voucherCategory = this.input_voucher_category?.code ?? voucherCategory;
				usageLimit = this.inputs.usage_limit ?? usageLimit;
				// const schoolYearStart = ((this.input_voucher_academic_calendar?.date_start ?? '0000') + '').substring(2, 4);
				// const schoolYearEnd = ((this.input_voucher_academic_calendar?.date_end ?? '0000') + '').substring(2, 4);
				// const schoolTerm = ((this.inputs?.school_term ?? '00') + '').padStart(2, '0');
				// const voucherSuffix = ('0000' + (this.input_voucher_suffix ?? '')).slice(-4);
				// this.inputs.voucher_code = voucherType + this.generateCurrentTerm + voucherSuffix;
				// return this.inputs.voucher_code;
			}
			this.fetchValidVoucherCode(voucherCategory, usageLimit)
				.then(res => {
					// console.log(res.data);
					if (isReward) {
						this.inputs.reward.voucher_code = res.data;
						this.reward.input_voucher_code = res.data[0] ?? '';
					} else {
						this.inputs.voucher_code = res.data;
						this.input_voucher_code = res.data.length > 1 ?
							`${res.data[0]} - ${res.data[res.data.length - 1]}` :
							(res.data[0] ?? '');
					}
				})
				.catch(res => console.log(res));
		},
		async fetchValidVoucherCode(prefix, limit = 1) {
			const res = await this.axiosPost({
				url: `${API_VOUCHER}/generate-code`,
				data: { prefix, limit },
				headers: {
					"Content-Type": "application/json",
				},
			});
			return res.data;
		},
		getWeekOfYear(date = new Date()) {
			const startOfYear = new Date(date.getFullYear(), 0, 1);
			const pastDays = (date - startOfYear) / 86400000; // ms in a day
			return Math.ceil((pastDays + startOfYear.getDay() + 1) / 7);
		},
		getTermByDate(date = new Date()) {
			if (typeof date === 'string') date = new Date(date);
			const week = this.getWeekOfYear(date);
			if (week <= 14) {
				return 3;
			}
			else if (week <= 26) {
				return 4;
			}
			else if (week <= 40) {
				return 1;
			}
			else {
				return 2;
			}
		},
		setVoucherSpecify(active) {
			this.inputs.usage_limit = 1;
			if (active) {
				// this.inputs.product_id = '';
				// this.inputs.package_name = '';
				// this.input_voucher_product = null;
				// this.input_voucher_package = null;
				this.input_voucher_lead_to = {};
			} else {
				this.inputs.lead_to_id = '';
				this.input_voucher_lead_to = null;
			}
		},
		setVoucherApplyReward(active) {
			if (!active) {
				this.reward = {};
				this.inputs.reward = {};
			}
		},
		setAcademicCalendarValue(data, isReward = false) {
			if (isReward) {
				if (data && data.hasOwnProperty("id")) {
					this.inputs.reward.academic_calendar_id = data.id;
				}
				if (data && data.hasOwnProperty("date_start")) {
					this.inputs.reward.school_term = this.getTermByDate(data.date_start);
					const date = new Date(data.date_start);
					date.setDate(date.getDate() - 1);
					this.inputs.reward.due_date = date;
				}
			} else {
				this.inputs.academic_calendar_id = this.inputs.academic_calendar_id;
				if (data && data.hasOwnProperty("id")) {
					this.inputs.academic_calendar_id = data.id;
					// this.input_voucher_academic_calendar = '';
				}
				if (data && data.hasOwnProperty("date_start")) {
					this.inputs.school_term = this.getTermByDate(data.date_start);
					const date = new Date(data.date_start);
					date.setDate(date.getDate() - 1);
					this.inputs.due_date = date;
				}
			}
		},
		setLeadToValue(data, isReward = false) {
			if (isReward) {
				if (data && data.hasOwnProperty("id")) {
					this.inputs.reward.lead_to_id = data.id;
				}
			} else {
				this.inputs.lead_to_id = this.inputs.lead_to_id;
				if (data && data.hasOwnProperty("id")) {
					this.inputs.lead_to_id = data.id;
					// this.input_voucher_lead_to = '';
				}
			}
		},
		// setProductValue(data) {
		// 	this.inputs.product_id = this.inputs.product_id;
		// 	if (data && data.hasOwnProperty("id")) {
		// 		this.inputs.product_id = data.id;
		// 		console.log('product_id: ' + data.id);
		// 		// this.input_voucher_product = '';
		// 	}
		// },
		// setPackageValue(data) {
		// 	this.inputs.package_name = this.inputs.package_name;
		// 	if (data && data.hasOwnProperty("package_name")) {
		// 		this.inputs.package_name = data.package_name;
		// 		// this.input_voucher_package = '';
		// 	}
		// },
		setVoucherCategoryValue(data, isReward = false) {
			if (isReward) {
				if (data && data.hasOwnProperty("id")) {
					this.inputs.reward.voucher_category_id = data.id;
				}
			} else {
				// this.inputs.voucher_category_id = this.inputs.voucher_category_id;
				if (data && data.hasOwnProperty("id")) {
					this.inputs.voucher_category_id = data.id;
					// this.input_voucher_category = '';
				}
			}
			this.generatedVoucherCode(isReward);
		},
	},
}
</script>
